module.exports = __webpack_public_path__ + "img/4c7b14917eabdacdf5566b90f6f4ef2d.svg";